const api = 'https://player.vimeo.com/api/player.js';
let apiLoaded = false;

export default class VimeoVideo {
  constructor(el, options) {
    this.el = el;
    this.options = options;

    this.isReady = false;
    this.onReadyCallback = null;
    this.onPlayCallback = null;
    this.startedPlaying = false;

    this.onApiLoaded = this._onApiLoaded.bind(this);
    this.onReady = this._onReady.bind(this);
    this.onProgress = this._onProgress.bind(this);

    if (apiLoaded) {
      this._onApiLoaded();
    } else {
      this._loadApi();
    }
  }

  /**
   * Load the Vimeo API: https://developer.vimeo.com/player/sdk/reference
   * @private
   */
  _loadApi() {
    const tag = document.createElement('script');
    tag.onload = () => this._onApiLoaded();
    tag.src = api;

    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  /**
   *
   * @returns {Promise} - Whether the video has begun playing or not
   * @public
   */
  play() {
    return new Promise((resolve, reject) => {
      this.onPlayCallback = resolve;
      this.onPlayError = reject;

      if (this.isReady) {
        this.player.play()
          .then(() => {
            this.player.on('progress', this.onProgress);
          }).catch(() => {
            this.player.off('progress', this.onProgress);
            this.onPlayError();
          });
      } else {
        this.onReadyCallback = () => {
          this.player.play()
            .then(() => {
              this.player.on('progress', this.onProgress);
            }).catch(() => {
              this.player.off('progress', this.onProgress);
              this.onPlayError();
            });
        };
      }
    });
  }

  /**
   * Pause the video
   * @public
   */
  pause() {
    if (this.player) {
      this.player
        .pause()
        .catch();
    }

  }

  /**
   * Unload the player
   * @public
   */
  unload() {
    if (this.player) {
      this.player
        .unload()
        .catch();
    }
  }

  /**
   * Initialize the player when the API has finished loading
   * @private
   */
  _onApiLoaded() {
    this.player = new window.Vimeo.Player(this.el);
    this.player
      .ready()
      .then(() => {
        this._onReady();
      })
      .catch(() => {
        this.onPlayError();
      });
    this.player.on('play', () => Core.Media.pauseAll(this.el));

    apiLoaded = true;
  }

  /**
   * Set the ready state and fire any callbacks when the player is ready
   * @private
   */
  _onReady() {
    this.isReady = true;

    if (this.onReadyCallback) {
      this.onReadyCallback();
    }
  }

  /**
   * Set the playing state and fire any callbacks when the video starts playing
   * @private
   */
  _onProgress() {
    this.startedPlaying = true;
    this.player.off('progress', this.onProgress);

    if (this.onPlayCallback) {
      this.onPlayCallback();
      this.onPlayCallback = null;
    }
  }
}
